<template>
	<CtaModal
		:open="isOpen"
		:title="t('extendedAccess.welcome.title')"
		:message="t('extendedAccess.welcome.message', { days: extendedAccessStore.daysLeft })"
		:features="extendedAccessBenefits"
		:confirm-label="t('extendedAccess.welcome.confirm')"
		@confirm="uiStore.dismissExtendedAccessWelcome"
		@dismiss="uiStore.dismissExtendedAccessWelcome"
	/>
</template>

<script setup lang="ts">
import { computed, watch } from "vue"
import { storeToRefs } from "pinia"
import { useI18n } from "vue-i18n"
import CtaModal from "@/components/modals/CtaModal.vue"
import { useExtendedAccessBenefits } from "@/composables/useExtendedAccessBenefits"
import { useExtendedAccessStore } from "@/stores/extendedAccessStore"
import { useUIStore } from "@/stores/uiStore"
import { ExtendedAccessStatus } from "@/types/extendedAccess"

const { t } = useI18n()
const uiStore = useUIStore()
const extendedAccessStore = useExtendedAccessStore()
const { isExtendedAccessWelcomePending } = storeToRefs(uiStore)
const { extendedAccess } = storeToRefs(extendedAccessStore)
const extendedAccessBenefits = useExtendedAccessBenefits()

const isOpen = computed(() => isExtendedAccessWelcomePending.value && extendedAccessStore.isActive)

watch(
	[isExtendedAccessWelcomePending, extendedAccess],
	([isPending, access]) => {
		if (!isPending) return
		if (!access) {
			extendedAccessStore.load()
		} else if (access.status !== ExtendedAccessStatus.Active) {
			uiStore.dismissExtendedAccessWelcome()
		}
	},
	{ immediate: true }
)
</script>
